import { fg } from '@atlaskit/platform-feature-flags';
import type { AdfParserConfig } from '@atlassian/adf-parser';

export function getParserConfig(): AdfParserConfig {
	return {
		filterInvalidMarks: fg('platform_editor_ai_filter_invalid_marks'),
		fuzzyNodeTypeMatching: fg('platform_editor_ai_adf_parser_fuzzy_node_matching'),
	};
}
